import { defineStore } from 'pinia';
import type { AnchorNavState } from '~~/types/vuex/AnchorNav';

export const anchorNavStore = defineStore('anchorNav', {
  state: () => ({
    activeSection: null,
    stickyAnchorNavHeight: 0,
  }),
  actions: {
    setActiveSection(payload: AnchorNavState['activeSection']) {

      this.activeSection = payload; 

    },
    setStickyAnchorNavHeight(payload: AnchorNavState['stickyAnchorNavHeight']) {

      this.stickyAnchorNavHeight = payload; 

    },
  },
});
